import { render, staticRenderFns } from "./option-details.vue?vue&type=template&id=67f8cb28&"
import script from "./option-details.vue?vue&type=script&lang=js&"
export * from "./option-details.vue?vue&type=script&lang=js&"
import style0 from "./option-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports